<div *ngIf="active" [ngClass]="isSharedLink ? 'shared-link' : ''" class="product-classification-panel-container">
    <div *ngIf="productClass==='Standard'" class="product-classification-panel-box ">
        <div class="classification">
            <span class="classification">Stock</span>
        </div>
    </div>
    <div *ngIf="productClass==='pro'" class="product-classification-panel-box product-classification-non-standard-pro">
        <div class="classification">
            <span class="classification">Pro</span>
        </div>
    </div>
    <div *ngIf="productClass==='proplus'" class="product-classification-panel-box product-classification-non-standard-proplus">
        <div class="classification">
            <span class="classification">Pro +</span>
        </div>
    </div>
    <div class="classificationTextContainer">
        <div *ngIf="productClass==='Standard'">
            {{ 'PRODUCT-CLASSIFICATION.CLASSIFICATION_PANEL_TEXT' | translate }}
            {{ 'PRODUCT-CLASSIFICATION.STANDARD_CELL' | translate }} <br>
            {{ 'PRODUCT-CLASSIFICATION.DELIVERY_TIME' | translate }}
            <span style="font-weight: bold;">
                {{ deliveryTimeInWeeks }}
                {{ 'PRODUCT-CLASSIFICATION.WEEKS' | translate }}
            </span>
        </div>
        <div *ngIf="productClass==='pro'">
            {{ 'PRODUCT-CLASSIFICATION.CLASSIFICATION_PANEL_TEXT' | translate }}
            {{ 'PRODUCT-CLASSIFICATION.PRO_CELL' | translate }} <br>
            {{ 'PRODUCT-CLASSIFICATION.DELIVERY_TIME' | translate }}
            <span style="font-weight: bold;">
                {{ deliveryTimeInWeeks }}
                {{ 'PRODUCT-CLASSIFICATION.WEEKS' | translate }}
            </span>
        </div>
        <div *ngIf="productClass==='proplus'">
            {{ 'PRODUCT-CLASSIFICATION.CLASSIFICATION_PANEL_TEXT' | translate }}
            {{ 'PRODUCT-CLASSIFICATION.PRO_PLUS_CELL' | translate }} <br>
            {{ 'PRODUCT-CLASSIFICATION.DELIVERY_TIME' | translate }}
            <span style="font-weight: bold;">
                {{ deliveryTimeInWeeks }}
                {{ 'PRODUCT-CLASSIFICATION.WEEKS' | translate }}
            </span>
        </div>
    </div>
</div>
